<template>
        <div
            class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0">
            <div class="col-xxl-8 col-10 text-start t-24 t-sm-18 t-md-24 t-xl-12 lh-1 t-xxl-9 label-1 mb-1 mb-xl-3 mt-4 mt-xl-0">
                Fecha de envió
            </div>

            <div class="col-xxl-8 col-10 d-flex flex-wrap justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <div class="w-100 d-flex flex-nowrap justify-content-start align-content-start align-items-stretch mt-4">
                    <div class="col-auto">
                        <div class="commonPageCheckbox">
                            <input name="sendMoment"  value="now" v-model="formFields.step3.sendDate" type="radio">
                            <label @keyup.enter="setValue('step3', 'sendDate', 'now')" tabindex="1" for="test" class="me-1 inputLabel" @click="setValue('step3', 'sendDate', 'now')">
                                <span class="pe-none"><img :src="simbol"></span>
                            </label>
                        </div>
                    </div>
                    <div role="button"  class="flex-fill d-flex flex-wrap justify-content-start align-content-start align-items-start" @click="setValue('step3', 'sendDate', 'now')">  
                        <div class="titleOption t-18 t-sm-15 t-xl-9 t-xxl-6 w-100 text-start ps-3">Enviar Ahora Mismo</div>
                        <div class="subtitleOption t-16 t-sm-13 t-xl-8 t-xxl-5 ps-xxl-5 ps-4 text-start">Al finalizar la orden comenzaremos a
                            preparar tu pedido.</div>
                    </div>
                </div>
                <div class="w-100 d-flex flex-nowrap justify-content-start align-content-start align-items-stretch mt-4 mt-xl-5">
                    <div class="col-auto">
                        <div class="commonPageCheckbox">
                            <input name="sendMoment" value="program" v-model="formFields.step3.sendDate" type="radio">
                            <label @keyup.enter="setValue('step3', 'sendDate', 'program')" tabindex="2" for="test" class="me-1 inputLabel" @click="setValue('step3', 'sendDate', 'program')">
                            <span class="pe-none"><img :src="simbol"></span></label>
                        </div>
                    </div>
                    <div role="button" class="flex-fill d-flex flex-wrap justify-content-start align-content-start align-items-start" @click="setValue('step3', 'sendDate', 'program')">
                        <div class="titleOption t-18 t-sm-15 t-xl-9 t-xxl-6 w-100 text-start ps-3">Programar Envío</div>
                        <div class="subtitleOption t-16 t-sm-13 t-xl-8 t-xxl-5 ps-xxl-5 ps-4 text-start">Se enviara en la fecha indicada.</div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5" v-if="formFields.step3.sendDate != 'now'">
                Indicar Fecha
            </div>
            <div v-if="formFields.step3.sendDate != 'now'"
                class="col-xxl-8 col-10 d-flex justify-content-between align-content-start align-items-start ps-xl-4 ps-2"
                :class="formFields.step3.sendDate == 'now' ? 'd-none pe-none opacity-50' : ''">
                <div class="col-md-5 col-4 d-flex me-2">
                    <select id="day" v-model="selectedDay" class="w-100 selectInput t-xxl-4 t-16 t-sm-11 t-xl-8">
                        <option v-for="day in days" :key="day.value" :value="day.value" :disabled="day.disabled">
                            {{ day.value }}
                        </option>
                    </select>
                </div>
                <div class="col-7 flex-fill ms-2">
                    <select id="month" v-model="selectedMonthIndex" class="w-100 selectInput t-xxl-4 t-16 t-sm-11 t-xl-8">
                        <option v-for="(month, midx) in months" :key="midx" :value="midx">
                            {{ month.name }} {{ month.year }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-else
                class="col-xxl-8 col-10 d-flex justify-content-between align-content-start align-items-start ps-xl-4 ps-2 mt-4">
                <div class="col-12 text-start d-flex me-2 t-xxl-3 t-16 t-sm-11 t-xl-8 labelDescription">
                    Al finalizar el pago enviaremos tu tarjeta
                </div>
            </div>

            <div class="col-xxl-8 col-10 text-start ts-2 mt-5 d-flex justify-content-end">
                <button class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24" @click="validateNextness()">Continuar</button>
            </div>
        </div>
</template>

<script>
import designList from '@/components/designList.vue'

export default {
    name: 'step3',
    emits: ['setData', 'progress', 'showModal', 'setLoading'],
    components: {
        designList
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    computed: {
        daysInMonth() {
            return this.getDaysInMonth(this.months[this.selectedMonthIndex].value);
        },
    },
    watch: {
        selectedMonthIndex() {
            this.updateDays();
        }
    },
    mounted() {
        this.initializeMonths().then(() => {
            this.updateDays();
        });
        this.mobile = this.isMobile();
    },
    methods: {
        validateNextness(){
            if(this.formFields.step3.sendDate == 'now'){
                this.setValue('step3', 'receiverDate', { value: this.currentMonth, name: this.getMonthName(this.currentMonth), year: this.currentYear, index:0, date:new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() });
            }else{
                let tempData = this.months[this.selectedMonthIndex];
                tempData.date = this.months[this.selectedMonthIndex].year + '/' + this.months[this.selectedMonthIndex].value + '/' + this.selectedDay;
                this.setValue('step3', 'receiverDate', tempData);
            }
            this.step(3);
        },
        setValue(step, field, value) {
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step) {
            this.$emit('progress', step);
        },
        initializeMonths() {
            return new Promise((resolve, reject) => {

                this.months = [];

                // Generar los próximos tres meses
                for (let i = 0; i < 3; i++) {
                    const monthDate = new Date(this.currentYear, this.currentMonth + i);
                    const month = monthDate.getMonth() + 1; // Ajustar a 1-12
                    const year = monthDate.getFullYear();
                    this.months.push({ value: month, name: this.getMonthName(month), year: year, index:month, date:'' });
                }

                if(this.formFields.step3.sendDate == 'now'){
                    this.selectedDay = this.currentDay;
                    let m = this.currentMonth+1;
                    for(let i in this.months){
                        if(this.months[i].value == m){
                            this.selectedMonthIndex = i;
                        }
                    }
                }else{
                    let m = new Date().getMonth()+1;
                    if(this.formFields.step3.receiverDate.date != ''){
                        this.selectedDay = new Date(this.formFields.step3.receiverDate.date).getDate();
                        m = new Date(this.formFields.step3.receiverDate.date).getMonth()+1;
                    }else{
                        this.selectedDay = new Date().getDate();
                    }
                    
                    for(let i in this.months){
                        if(this.months[i].value == m){
                            this.selectedMonthIndex = i;
                        }
                    }
                }

                resolve(true)
            });
            
        },
        getMonthName(month) {
            const monthNames = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            return monthNames[month - 1];
        },
        updateDays() {
            if (this.selectedMonthIndex !== null && this.months.length > 0) {
                const daysInMonth = new Date(this.months[this.selectedMonthIndex].year, this.months[this.selectedMonthIndex].value, 0).getDate();
                this.days = [];
                for (let day = 1; day <= daysInMonth; day++) {
                    // Si el mes seleccionado es el mes actual, deshabilitar días pasados
                    const isDisabled = this.months[this.selectedMonthIndex].value === (this.currentMonth+1) && day < this.currentDay;
                    this.days.push({ value: day, disabled: isDisabled });
                }
                // Ajustar el día seleccionado si es mayor que los días disponibles en el nuevo mes
                if (this.selectedDay > daysInMonth) {
                    this.selectedDay = daysInMonth;
                }
                // Si el mes seleccionado es el mes actual y el día seleccionado es anterior al día actual
                if (this.months[this.selectedMonthIndex].value === (this.currentMonth+1) && this.selectedDay < this.currentDay) {
                    this.selectedDay = this.currentDay;
                }
            }
        }
    },
    data() {

        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth(); // Los meses en JavaScript van de 0 a 11
        const currentDay = today.getDate();

        return {
            simbol: require('@/assets/images/a27.svg'),
            months: [],
            days: [],
            mobile: false,
            currentYear,
            currentMonth,
            currentDay,
            selectedMonthIndex: null,
            selectedDay: this.formFields.step3.receiverDate != '' ? new Date(this.formFields.step3.receiverDate.date).getDate() : currentDay,
        }
    }
}
</script>

<style scoped lang="css">
.titleOption {
    color: var(--primary);
    font-weight: 600;
}

.labelDescription {
    color: var(--secondary);
    font-weight: 600;
}

.label-1{
    line-height: 2;
    font-weight: 700;
    color:var(--secondaryText)
}

.subtitleOption {
    color: var(--sexagenary);
}

.inputText {
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 12px;
    color: var(--primary);
}

.selectInput {
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 12px;
    color: var(--primary);
    outline: none;
    appearance: none;
}


textarea {
    resize: none;
}


.checkBoxArea{
    padding-top: 19px;
    height: 100%;
    flex-shrink: 0;
}
.commonPageCheckbox input:not(:checked) + label:hover{
    border:5px solid var(--secondary);
}
.commonPageCheckbox input:not(:checked) + label>span{
    display: none;
}
.commonPageCheckbox input{
    display: none;
}
.commonPageCheckbox label{
    cursor:pointer;
    width: 30px;
    height: 30px;
    border:3px solid var(--quinary);
    border-radius: 6px;
    overflow: visible;
}
.commonPageCheckbox img{
    width: 100%;
    height: 100%;
    margin-left: 15%;
    transform: scaleX(2.2) scaleY(2.2) translateY(-10%);
}
.commonPageCheckbox span{
    background-color: transparent;
}
@media (min-width: 768px) {
    .commonPageCheckbox label{
        border:5px solid var(--quinary);
        width: 40px;
        height: 40px;
    }
}
</style>
